export interface Ping {
    iteration: number;
    pingTime: number;
}

export enum Servers {
    'api.pddtest.kz' = 'api.pddtest.kz',
    'media.pddtest.kz' = 'media.pddtest.kz/upload/123',
    'srv1.pddtest.kz' = 'srv1.pddtest.kz/v1/123',
    'tunnel.kursant.kz' = 'tunnel.kursant.kz'
}

export type PingResults = Record<Servers, {
    url: string,
    ping: Ping[]
}>